import { useMutation } from "@tanstack/react-query";

import { cognitoMigrationService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

/**
 * Migrates one patient to Cognito (EN-5222). The page calls it once per
 * selected row, in sequence; it does NOT invalidate the list on each call — a
 * refetch mid-run would re-check every row's Cognito status and race the run.
 * The page invalidates once when the run ends.
 */
export function useMigratePatientToCognito() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (patientId: number) =>
      ensureOk(await cognitoMigrationService.migratePatient(patientId)),
  });

  return { migratePatient: mutateAsync, isMigrating: isPending };
}
